import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  IconButton,
  Typography,
  CircularProgress
} from "@mui/material";
import { RefreshCw, X, RotateCcw } from "lucide-react";
import { useSelector } from "react-redux";
import ExternalDispatchManager from "./ExternalDispatchManager";

const ExternalDispatch = ({ onClose, selectedRow, thirdPartyAffiliateToSelect }) => {
  const {ThirdPartyExternalAffiliatesData, isLoading } = useSelector((store) => store.combinedata);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [selectedAffiliate, setSelectedAffiliate] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [options, setOptions] = useState([]);

  const SelectedComponent = selectedLabel ? ExternalDispatchManager(selectedLabel) : null;

  const handleClose = () => {
    setSelectedLabel("");
    setSelectedAffiliate("-1");
    if (onClose) onClose();
  };

  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
    setSelectedLabel("");
    setSelectedAffiliate("-1");

    const options = ThirdPartyExternalAffiliatesData?.map(a => ({
      value: a.AffiliateID,
      label: a.AffiliateCompany
    }));
    
    // First: check if thirdPartyAffiliateToSelect should be selected
    if (thirdPartyAffiliateToSelect !== -1) {
    
      const exists = options?.some(
        o => o.value === thirdPartyAffiliateToSelect
      );
    
      if (exists) {
        setSelectedAffiliate(thirdPartyAffiliateToSelect);
        setSelectedLabel(
          options.find(o => o.value === thirdPartyAffiliateToSelect)?.label
        );
        setOptions(options);
        return; // stop here, since selection is done
      }
    }
    
    // Second: fallback → if only ONE option exists, select it
    if (options?.length === 1) {
      const key = parseInt(options[0].value);
      setSelectedAffiliate(key);
      setSelectedLabel(options[0].label);
      setOptions(options);
    }
  };

  // const options = [
  //   { label: "Uber", value: "Uber" }
  //   //{ label: "ModiveCare", value: "ModiveCare" },
  // ];

  useEffect(() => {
    if (options.length === 1) {
      const singleValue = options[0].label;
      setSelectedLabel(singleValue);
    }
  }, [options]);

  const getColors = (value) => {
    switch (value) {
      case "Uber":
        return { /*backgroundColor: "black", color: "white"*/ fontWeight: "bold" };
      case "1":
        return { backgroundColor: "pink", color: "white" };
      case "2":
        return { backgroundColor: "yellow", color: "black" };
      default:
        return { backgroundColor: "white", color: "black" };
    }
  };


  useEffect(() => {
    const options = ThirdPartyExternalAffiliatesData?.map(a => ({
      value: a.AffiliateID,
      label: a.AffiliateCompany
    }));
    
    // First: check if thirdPartyAffiliateToSelect should be selected
    if (thirdPartyAffiliateToSelect !== -1) {
    
      const exists = options?.some(
        o => o.value === thirdPartyAffiliateToSelect
      );
    
      if (exists) {
        setSelectedAffiliate(thirdPartyAffiliateToSelect);
        setSelectedLabel(
          options.find(o => o.value === thirdPartyAffiliateToSelect)?.label
        );
        setOptions(options);
        return; // stop here, since selection is done
      }
    }
    
    // Second: fallback if only ONE option exists, select it
    if (options?.length === 1) {
      const key = parseInt(options[0].value);
      setSelectedAffiliate(key);
      setSelectedLabel(options[0].label);
      setOptions(options);
    }



    
  }, [])

  const setAndFetchAffiliate = (e) => {
    try {
      const key = parseInt(e.target.value);   // <-- this is your AffiliateID
      setSelectedAffiliate(key);     // save the key
      let selectedAffiliateName = options.find(o => o.value === key)?.label;
      setSelectedLabel(selectedAffiliateName);  
    } catch (error) {
      
    }
  }

  const { backgroundColor, color } = getColors(selectedLabel);

  return (
    //TODO: Later on add the isLoading.....
    //{(isLoading || isLoadingSmartDeviceData) ? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" style={{ marginBottom: "3px" }} />) : ""}
    <>
        {
        (isLoading ? (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255, 255, 255, 0.7)', // light overlay
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 999,
            }}
          >
          <CircularProgress
            size={16}            
            thickness={4}        
            sx={{ ml: 1, mb: '3px' }}
          />
            <label style={{marginLeft: "10px",fontSize: "larger",marginBottom: "5px"}}>Please wait, Loading Data....</label>
          </div>
        ) : 
    
    
    <Box
      sx={{
        border: 0,
        borderColor: "divider",
        borderRadius: 2,
        backgroundColor: "background.paper",
      }}
    >

    <Box
      sx={{
        border: 0,
        borderColor: "divider",
        borderRadius: 2,
        backgroundColor: "background.paper"}}
        style={{marginRight: "3%"}}>
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end" 
            spacing={1}
            style={{marginRight: "3%"}}
            >
        <Typography sx={{ mb: 1, pr: 1 }}>
          Confirmation# {" " + selectedRow[0].iRefID}
        </Typography>
        </Stack>
    </Box>

      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ p: 0.5, borderBottom: 1, borderColor: "divider" }}>
        <Typography variant="h6" sx={{ mb: 1, pr: 1 }} style={{fontWeight: "bold"}}>
          TNC
        </Typography>
        <select
            className='text-center p-1 w-100 ms-1' 
            style={{ border:"0.1px solid lightgray", borderRadius:"0px",  backgroundColor,color}}
            value={selectedAffiliate}
            onChange={(e) => 
              {
                setAndFetchAffiliate(e);
              }
            }
            size="small"
            sx={{ minWidth: 150 }}>
          {options.map((opt, i) => (
            <option key={i} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={1}>
          <IconButton onClick={handleRefresh} color="primary" disabled={!selectedLabel}>
            <RotateCcw size={18} />
          </IconButton>
          {/* <IconButton onClick={handleClose} color="error">
            <X size={18} />
          </IconButton> */}
        </Stack>
      </Stack>

   
        {SelectedComponent ? (
          <Box sx={{ p: 1/*, overflow: "auto", height: "85vh"*/ }} >
            <SelectedComponent key={refreshKey}  type={selectedLabel} selectedAffiliate={selectedAffiliate} selectedRow={selectedRow}/>
            </Box>
        ) : (
          <Box sx={{ p: 1,  height: "100%", textAlign: "center", fontWeight: "bold", display: "flex", justifyContent: "center", fontSize: "large", alignItems: "center" }} >
            <Typography color="text.secondary">Select a TNC to continue</Typography>
          </Box>
        )}
    </Box>
  )}
    </>
  );
};

export default ExternalDispatch;